var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"routeContainer"},[_c('v-breadcrumbs',{attrs:{"divider":"/","items":_vm.breadcrumbsItems}}),_vm._l((_vm.items),function(item){return _c('div',{key:item.name},[_c('NestedExploreComponent',{attrs:{"dataObj":item,"itemRoute":_vm.route}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }